import { useState } from 'react'
import { Form, Button, Table, Row, Col } from 'react-bootstrap'
import * as XLSX from 'xlsx'
import { toast } from 'react-toastify'
import { useCreateLandlordMutation} from '../../slices/landlordsApiSlice'

const LandlordImportScreen = () => {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [createLandlord] = useCreateLandlordMutation()

  const handleFileUpload = (e) => {
    const file = e.target.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result)
      const workbook = XLSX.read(data, { type: 'array' })
      const sheet = workbook.Sheets[workbook.SheetNames[0]]
      const parsed = XLSX.utils.sheet_to_json(sheet)

      setRows(parsed)
    }
    reader.readAsArrayBuffer(file)
  }

  const handleSubmitAll = async () => {
    setLoading(true)
    for (const row of rows) {
      const { name, telephone, company, serialNumber, address } = row
      if (!name || !telephone || !company || !serialNumber || !address) {
        toast.warn(`Skipping incomplete row: ${JSON.stringify(row)}`)
        continue
      }
      try {
        await createLandlord({ name, telephone, company, serialNumber, address }).unwrap()
        toast.success(`Created: ${name}`)
      } catch (err) {
        toast.error(`Error for ${name}: ${err?.data?.message || err.error}`)
      }
    }
    setLoading(false)
  }

  return (
    <>
      <Row className="mb-4">
        <Col md={6}>
          <h2>Import Landlords from Excel</h2>
          <Form.Group controlId="excelFile">
            <Form.Label>Select Excel File</Form.Label>
            <Form.Control type="file" accept=".xlsx,.xls" onChange={handleFileUpload} />
          </Form.Group>
        </Col>
        <Col md={6} className="text-end">
          <Button onClick={handleSubmitAll} disabled={loading || rows.length === 0}>
            {loading ? 'Submitting...' : 'Submit All Rows'}
          </Button>
        </Col>
      </Row>

      {rows.length > 0 && (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Name</th>
              <th>Telephone</th>
              <th>Company</th>
              <th>Serial Number</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td>{r.name}</td>
                <td>{r.telephone}</td>
                <td>{r.company}</td>
                <td>{r.serialNumber}</td>
                <td>{r.address}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  )
}

export default LandlordImportScreen